<script>
    import { onMount } from 'svelte';
    export let propsForForm;
    let username;
    let canEditUsername = false;

    const [postUid] = propsForForm;

    async function getUsername() {
        const data = await fetch('/api/v1/get-username');
        return await data.json();
    }

    async function renderUi() {
        // check for username in frontend.
        // if no username found in frontend, check backend.
        const { username: _username } = await getUsername();
        // if found in backend, modal should show the shareable url.

        // if no username exists yet, show a UI input for username in the modal.
        if (!_username) {
            canEditUsername = true;
        } else {
            username = _username;
        }
    }

    async function createUsername() {
        canEditUsername = false;
        const body = { method: 'POST', body: JSON.stringify({ username }) }
        const data = await fetch('/api/v1/update-username', body);
        const response = await data.json();

        if (!response.success) {
            usernameError = true;
            canEditUsername = true;
        }
    }
    
    onMount(async() => {
        await renderUi();
    })
</script>

<main>

    {#if canEditUsername}
        <form id="new-username-form">
            <input bind:value={username} class="input" type="text" name="subscription-name" autocomplete="off" placeholder="username" data-required="true" required />
            <button on:click|preventDefault={() => createUsername()} type="submit" form="new-username-form" class="primary-green">
                create username
            </button>
        </form>
    {/if}

    <div>https://evergreenfeeds.com/<bold>{username}</bold>/d/{postUid}</div>
</main>